import type { ReactNode } from 'react';
import { Dialog as AriaDialog, Heading, Modal, ModalOverlay } from 'react-aria-components';
import styles from './Dialog.module.css';

/** Eigenschaften des Dialogs. */
interface DialogProps {
  /** Überschrift (zugleich zugänglicher Name des Dialogs). */
  title: string;
  /** Ob der Dialog geöffnet ist. */
  isOpen: boolean;
  /** Wird beim Schließen (Escape, Klick daneben) aufgerufen. */
  onClose: () => void;
  /** Inhalt des Dialogs. */
  children: ReactNode;
  /** `wide` für große Inhalte wie die Bildansicht (Standard: schmal). */
  size?: 'default' | 'wide';
}

/**
 * Modaler, barrierefreier Dialog (Fokusfalle, Escape, Rückgabe des Fokus) auf Basis von
 * `react-aria-components`. Dient als Grundlage für Formular- und Bestätigungsdialoge.
 * @param props Titel, Sichtbarkeit, Schließen-Callback und Inhalt.
 */
export function Dialog({ title, isOpen, onClose, children, size = 'default' }: DialogProps) {
  return (
    <ModalOverlay
      className={styles.overlay}
      isOpen={isOpen}
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
      isDismissable
    >
      <Modal className={size === 'wide' ? `${styles.modal} ${styles.wide}` : styles.modal}>
        <AriaDialog className={styles.dialog}>
          <Heading slot="title" className={styles.title}>
            {title}
          </Heading>
          {children}
        </AriaDialog>
      </Modal>
    </ModalOverlay>
  );
}
